export default "/logo.1d8a4271-7e9d40.png";